import { render, staticRenderFns } from "./GameVersion-add.vue?vue&type=template&id=5358e10e&"
import script from "./GameVersion-add.vue?vue&type=script&lang=js&"
export * from "./GameVersion-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports